import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export function SmartlookTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.smartlook) {
      console.log("track teste");
      window.smartlook("track", "teste_roberta", {
        url: location.pathname,
      });
    }
  }, [location]);

  return null;
}
